export default __webpack_public_path__ + "content/media/8.da5b0515.jpg";